<template>
    <div v-resize="onResize">
        <h2>Polling places for {{ division }} ({{ state }})</h2>
        <br/>  
        <loader v-if="loading" /> 
        <v-data-table 
            v-if="!loading"
            :headers="headers"                    
            :disable-initial-sort="true"
            :hide-headers="isMobile"
            :class="{ mobileDataTable: isMobile, 'elevation-1': true }"
            :items="data">

            <template v-slot:items="props">
                <router-link v-if="isMobile" class="tr" :to="{ name: 'PollingPlace', params: { pollingPlace: props.item.Name }}">
                    <td>
                        <div class="flex-content">
                            <div class="flex-item pt-2">
                                <h3 class="pb-xs-0">
                                    {{ props.item.Name }}
                                </h3>
                            </div>
                            <div class="flex-item">
                                {{ props.item.StreetAddress }}
                            </div>
                        </div>
                    </td>
                </router-link>
                <router-link v-else class="tr" :to="{ name: 'PollingPlace', params: { pollingPlace: props.item.Name }}">
                    <td class="text-xs-left">{{ props.item.Name }}</td>
                    <td class="text-xs-left">{{ props.item.StreetAddress }}</td>
                </router-link>
            </template>
        </v-data-table>
    </div>
</template>
<script>
import Loader from '@/components/Loader.vue';
import axios from 'axios';
window.Handbook = window.Handbook || {}
const apiUri = window.Handbook.ApiUri || "https://localhandbookapi.aph.gov.au/";
axios.defaults.baseURL = apiUri;

export default {
    props: ['division', 'state', 'year'],
    components: {
        Loader
    },
    created() {
        this.initialiseData();
    },
    mounted() {
        this.onResize();
    },
    data() {
        return {
            data: [],
            isMobile: false,
            loading: true,
            showAddress: false
        }
    },
    computed: {
        headers() {
            const headers = [{
                text: 'Polling place',
                value: 'Name'
            }];
            if (this.showAddress) {
                headers.push({
                    text: 'Street address',
                    value: 'StreetAddress'
                });

            }
            return headers;
        }
    },
    methods: {
        initialiseData: function () {
            this.loading = true;
            const url = `Elections/PollingPlaces?divisionName=${this.division}&year=${this.year}`;
            axios.get(`api/${url}`)
                .then(response => {
                    this.data = response.data;
                    // determine whether or not to show address based on data
                    if (this.data.findIndex(d => d.StreetAddress) !== -1) {
                        this.showAddress = true;
                    }
                    this.loading = false;
                    this.$emit('loaded', this.data.length > 0);
                });
        },
        onResize() {
            if (window.innerWidth < 769){
                this.isMobile = true;
            }
            else{
                this.isMobile = false;
            }
        },
    }
}

</script>